import React from 'react';
import { Section } from './Section';
import { CountdownDisplay } from './Countdown';
export function FinalCtaSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="bg-bgAlt py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-67">
      <div className="moon-glow top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-40" data-id="element-68"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-69">
        <div className="text-6xl mb-8 opacity-80" data-id="element-70">🌙</div>

        <div className="inline-flex items-center gap-2 bg-dangerSoft/10 text-dangerSoft border border-dangerSoft/20 px-4 py-1.5 rounded-full text-sm font-bold mb-8" data-id="element-71">
          <span data-id="element-72">⏰</span> EL PRECIO CIERRA EN:
        </div>

        <div className="mb-12" data-id="element-73">
          <CountdownDisplay data-id="element-74" />
        </div>

        <div className="flex flex-col md:flex-row gap-4 justify-center items-center mb-12" data-id="element-75">
          <button onClick={scrollToPricing} className="w-full md:w-auto cta-secondary font-bold py-4 px-8 rounded-xl transition-all flex items-center justify-center gap-2" data-id="element-76">
            <span data-id="element-77">📘</span> → QUIERO EL PLAN BASE — $19.990 ARS
          </button>

          <button onClick={scrollToPricing} className="w-full md:w-auto cta-primary font-bold py-4 px-8 rounded-xl transition-all flex items-center justify-center gap-2" data-id="element-78">
            <span data-id="element-79">🏆</span> → QUIERO LA EDICIÓN COMPLETA — $27.990 ARS
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-bodyOnDark" data-id="element-80">
          <span className="flex items-center gap-1" data-id="element-81">🔒 Pago 100% seguro</span>
          <span className="hidden md:inline" data-id="element-82">|</span>
          <span className="flex items-center gap-1" data-id="element-83">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="hidden md:inline" data-id="element-84">|</span>
          <span className="flex items-center gap-1" data-id="element-85">🛡️ Garantía 7 días</span>
        </div>

        <div className="mt-6 text-xs text-bodyOnDark/60 flex items-center justify-center gap-2" data-id="element-86">
          💳 Mercado Pago | Tarjeta | Transferencia
        </div>
      </div>
    </Section>;
}